import Axios from 'axios';
import { ReactElement } from 'react';

import FrontImage from '../../assets/images/LandingPage/peer_learning.png';
import PricingPageContent from '../../components/_organisms/PricingPageContent';
import { NextPageWithLayout } from '../../components/layouts';
import LandingPageLayout from '../../components/layouts/LandingPageLayout';
import { configureStore } from '../../utils/store';

// eslint-disable-next-line @typescript-eslint/no-explicit-any
const PricingPage: NextPageWithLayout<{ prices: any[] }> = ({ prices }) => {
  return <PricingPageContent prices={prices} />;
};

export async function getStaticProps() {
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  const res = await Axios.get<{ prices: any[] }>(
    `${
      process.env.isLocal
        ? 'http://localhost:3010'
        : configureStore().config.backend.externalApiUrl
    }/v0.5/payments/prices/business`,
  );

  return {
    props: {
      prices: res.data.prices,
    },
  };
}

PricingPage.getLayout = function getLayout(page: ReactElement) {
  return (
    <LandingPageLayout
      title="Pricing"
      subTitle="Pricing details for businesses"
      primaryActionText="Sign up - It's free"
      image={FrontImage}
      hideBlobs={false}
    >
      {page}
    </LandingPageLayout>
  );
};

export default PricingPage;
